import { z } from "zod";

/**
 * Campaign sender (channel-agnostic). Lives in its own file — imported + re-exported by `list.ts` —
 * to keep that schema module within the length ratchet.
 */
export const SenderSchema = z.object({
	uuid: z.string(),
	deactivated: z.boolean(),
	userId: z.number(),
	active: z.boolean(),
	name: z.string(),
	firstName: z.string(),
	lastName: z.string(),
	type: z.string(),
	emailAddress: z.string().optional(),
	emailType: z.string().optional(),
	emailId: z.number().optional(),
	signature: z.string().optional(),
});
